import React, { useState } from 'react';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import InputText from '../../Common/InputText';
import Drawer from '../../Common/Drawer/Drawer';

interface BaselineCopyFormProps {
    originBaselineName: string;
    isLoading: boolean;
    copyBaseline: (name: string, description: string) => void;
    cancelClick: () => void;
}

const BaselineCopyForm: React.FC<BaselineCopyFormProps> = ({
    originBaselineName,
    isLoading,
    copyBaseline,
    cancelClick,
}) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [isFormValid, setIsFormValid] = useState(true);

    const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name: field, value } = e.target;
        if (field === 'name') setName(value);
        if (field === 'description') setDescription(value);
    };

    const copyBaselineClick = () => {
        if (!name) {
            setIsFormValid(false);
            return;
        }
        copyBaseline(name, description);
    };

    return (
        <Drawer
            isWide={false}
            title={`Copy Baseline: ${originBaselineName}`}
            saveText='Create'
            onSaveClick={copyBaselineClick}
            isSaveDisabled={isLoading}
            onCancelClick={cancelClick}>
            <LoadingIndicator isLoading={isLoading} hideWhileLoading isFullscreen>
                <form noValidate className={isFormValid ? '' : 'was-validated'}>
                    <InputText
                        name='name'
                        label='Name'
                        placeholder='Name'
                        type='text'
                        value={name}
                        onChange={onTextChange}
                        isRequired
                        errorMessage='Name is required'
                        maxLength={100}
                    />
                    <InputText
                        name='description'
                        label='Description'
                        placeholder='Description'
                        type='text'
                        value={description}
                        onChange={onTextChange}
                        isRequired={false}
                        maxLength={1200}
                    />
                </form>
            </LoadingIndicator>
        </Drawer>
    );
};

export default BaselineCopyForm;